import React, { useState } from "react";
import { Table, Pagination } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import Loader from "components/Loader";
import { INVOICE_STATUS } from "common/constants";
import { toast } from "react-toastify";
import axios from "axios";
import { locale } from "dayjs";

export const SalaryList = ({
  Salaries,
  t,
  setShow,
  promiseState,
  items,
  activePagination,
  pageCount,
}) => {
    const [loading, setLoading] = useState(false);
  
   const getSalarySlipData = async (identifier, salaryType) => {
    setLoading(true);
    try {
      const lang = localStorage.getItem("i18nextLng") || locale;      
      const URL = `/salary/salary-slip-pdf?id=${identifier}&locale=${lang}&salaryType=${salaryType}`;

       const result = await axios.get(URL, { responseType: 'blob' }); 
      if (result?.status === 200) {
        setLoading(false);
        const data = result.data;
        const url = window.URL.createObjectURL(data);
        window.open(url, '_blank');
        const link = document.createElement('a');
        link.href = url;
        
        const filename = salaryType === 3 
          ? `${identifier}ManualSalarySlip.pdf`
          : `${identifier}SalarySlip.pdf`;
        
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };
  return (
    <>
    {loading && <Loader />}
      {promiseState?.pending && <Loader />}
      <div className="table-div">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th className="invoice_tabeletext">{t("Serial No.")}</th>
              <th className="invoice_tabeletext">{t("Customer")}</th>
              <th className="invoice_tabeletext">{t("Created")}</th>
              <th className="invoice_tabeletext">{t("Salary Type")}</th>
              <th className="invoice_tabeletext">{t("Invoice No")}</th>
              <th className="invoice_tabeletext">{t("Holiday Payout No.")}</th>
              <th className="invoice_tabeletext">{t("Amount")}</th>
              <th className="invoice_tabeletext">{t("Invoice Status")}</th>
              <th className="invoice_tabeletext">{t("Salary Status")}</th>
              <th className="invoice_tabeletext text-center">{t("Action")}</th>
            </tr>
          </thead>
          <tbody>
            {Salaries?.map((cell, index) => {
              const serialNumber =
                (activePagination - 1) * pageCount + index + 1;
              return (
                <tr key={index}>
                  <td>{serialNumber}</td>
                  <td>
                    {cell?.signUpUser?.firstName +
                      " " +
                      cell?.signUpUser?.lastName}
                  </td>
                  <td>{cell?.createdDate.split("T")[0]}</td>
                  <td>
                    {cell?.salaryType === 1
                      ? t("Invoice")
                      : cell?.salaryType === 2
                      ? t("Holiday Payout")
                      : t("Manual Salary")}
                  </td>
                  <td>{cell?.invoice?.invoiceNumber || "-"}</td>
                  <td>{cell?.holidayPayoutId || "-"}</td>

                  <td>{cell?.amount}</td>
                  <td>
                    {cell?.salaryType === 2 || cell?.salaryType === 3
                      ? "-"
                      : cell?.invoice?.invoiceStatus === INVOICE_STATUS.UNPAID
                      ? t("Unpaid")
                      : cell?.invoice?.invoiceStatus === INVOICE_STATUS.PAID
                      ? t("Paid")
                      : t("Partial")}
                  </td>
                  <td>{cell?.paid === true ? t("Paid") : t("Unpaid")}</td>

                  <td className="d-flex justify-content-center align-items-center height">
                    <div className="hover-text">
                      <button
                        id="top"
                        className="salary_view"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={t("View")}
                        onClick={() => {
                          const identifier = cell?.salaryType === 3 
                            ? cell?.id || cell?.salaryId 
                            : cell?.invoice?.invoiceNumber;
                          
                          if (identifier) {
                            getSalarySlipData(identifier, cell?.salaryType);
                          } else {
                            toast.error(t("Unable to generate salary slip - missing identifier"));
                          }
                        }}
                      >
                        <FaEye size={14} />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        {promiseState?.pending ? null : Salaries?.length === 0 &&
          promiseState?.fulfilled ? (
          <div className="text-center">
            <h2>{t("No data found")}</h2>
          </div>
        ) : promiseState?.rejected ? (
          <div className="text-center">
            <h2>{t("Found an error please try again within few minutes")}</h2>
          </div>
        ) : (
          ""
        )}

        <div className="paginationInvoice">
          <Pagination style={{ flexWrap: "wrap" }}>{items}</Pagination>
          <br />
        </div>
      </div>
    </>
  );
};
